export type PhoneMessages = {
  ddiBrazilOption: string;
  noDDI: string;
};

export const PHONE_MESSAGES: PhoneMessages = {
  ddiBrazilOption: "Brasil",
  noDDI: "Nenhum",
};
